import React, { useEffect, useState } from 'react'
import fadeIn from '../../stitches/animations/fadeIn'
import { styled } from '../../stitches/stitches.config'

type Props = {
  src: string
  onFadeInCompleted?: () => void
}

const FadeInImage: React.FC<Props> = ({ src, onFadeInCompleted }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFadeInCompleted?.()
    }, 2000)

    return () => clearTimeout(timer) // Cleanup function
  }, [src])

  return <Image alt="banner" src={src} />
}

export default FadeInImage

const Image = styled('img', {
  width: '100%',
  animationDuration: '2s',
  animationTimingFunction: 'ease',
  animationFillMode: 'forwards',
  animationName: `${fadeIn}`,
})
